/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8.5 9.49985L6 11.9999L8.5 14.4999M15.4999 9.49976L18 11.9999L15.5 14.4999"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13 7L11 17M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M8.5 9.5L6 12L8.5 14.5M15.5 9.4999L18 12L15.5 14.5M13 7L11 17M22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2L10 2C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02434 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM13.7354 7.14717C13.8167 6.741 13.5533 6.34588 13.1471 6.26465C12.7409 6.18341 12.3458 6.44683 12.2646 6.853L10.2646 16.853C10.1833 17.2592 10.4467 17.6543 10.8529 17.7355C11.2591 17.8168 11.6542 17.5533 11.7354 17.1472L13.7354 7.14717ZM16.0303 8.96966C15.7374 8.67676 15.2625 8.67676 14.9696 8.96965C14.6767 9.26254 14.6767 9.73742 14.9696 10.0303L16.9393 12.0001L14.9696 13.9698C14.6767 14.2627 14.6767 14.7376 14.9696 15.0305C15.2625 15.3234 15.7374 15.3234 16.0303 15.0305L18.5303 12.5304C18.8232 12.2375 18.8232 11.7626 18.5303 11.4698L16.0303 8.96966ZM9.03034 10.0304C9.32323 9.73751 9.32322 9.26264 9.03032 8.96975C8.73743 8.67686 8.26256 8.67686 7.96966 8.96976L5.46966 11.4698C5.32901 11.6105 5.25 11.8012 5.25 12.0001C5.25 12.1991 5.32902 12.3898 5.46968 12.5305L7.96968 15.0304C8.26257 15.3233 8.73744 15.3233 9.03034 15.0304C9.32323 14.7375 9.32322 14.2626 9.03032 13.9697L7.06066 12.0001L9.03034 10.0304Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M8.5 9.5L6 12L8.5 14.5M15.5 9.4999L18 12L15.5 14.5M13 7L11 17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M8.5 9.5L6 12L8.5 14.5M15.5 9.4999L18 12L15.5 14.5M13 7L11 17M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.1471 6.26471C13.5533 6.34594 13.8167 6.74106 13.7354 7.14723L11.7354 17.1472C11.6542 17.5534 11.2591 17.8168 10.8529 17.7356C10.4467 17.6543 10.1833 17.2592 10.2646 16.8531L12.2646 6.85306C12.3458 6.44689 12.7409 6.18348 13.1471 6.26471ZM14.9696 8.96971C15.2625 8.67682 15.7374 8.67683 16.0303 8.96972L18.5303 11.4698C18.8232 11.7627 18.8232 12.2376 18.5303 12.5305L16.0303 15.0305C15.7374 15.3234 15.2625 15.3234 14.9696 15.0305C14.6767 14.7376 14.6767 14.2628 14.9696 13.9699L16.9393 12.0001L14.9696 10.0304C14.6767 9.73748 14.6767 9.2626 14.9696 8.96971ZM9.03032 8.96981C9.32322 9.2627 9.32323 9.73757 9.03034 10.0305L7.06066 12.0002L9.03032 13.9698C9.32322 14.2627 9.32323 14.7376 9.03034 15.0305C8.73744 15.3234 8.26257 15.3234 7.96968 15.0305L5.46968 12.5305C5.32902 12.3899 5.25 12.1991 5.25 12.0002C5.25 11.8013 5.32901 11.6105 5.46966 11.4699L7.96966 8.96982C8.26256 8.67692 8.73743 8.67692 9.03032 8.96981Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
